import { createIcon } from '@chakra-ui/icon'

export const DeviceConfigurationIcon = createIcon({
  displayName: 'DeviceConfigurationIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      width="25"
      height="26"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16699 3.6862C3.70675 3.6862 3.33366 4.05929 3.33366 4.51953V16.1862C3.33366 16.6464 3.70675 17.0195 4.16699 17.0195H15.8337C16.2939 17.0195 16.667 16.6464 16.667 16.1862V4.51953C16.667 4.05929 16.2939 3.6862 15.8337 3.6862H4.16699ZM1.66699 4.51953C1.66699 3.13882 2.78628 2.01953 4.16699 2.01953H15.8337C17.2144 2.01953 18.3337 3.13882 18.3337 4.51953V16.1862C18.3337 17.5669 17.2144 18.6862 15.8337 18.6862H4.16699C2.78628 18.6862 1.66699 17.5669 1.66699 16.1862V4.51953Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0003 13.6862C11.8413 13.6862 13.3337 12.1938 13.3337 10.3529C13.3337 8.51192 11.8413 7.01953 10.0003 7.01953C8.15938 7.01953 6.66699 8.51192 6.66699 10.3529C6.66699 12.1938 8.15938 13.6862 10.0003 13.6862ZM10.0003 15.3529C12.7617 15.3529 15.0003 13.1143 15.0003 10.3529C15.0003 7.59144 12.7617 5.35286 10.0003 5.35286C7.2389 5.35286 5.00033 7.59144 5.00033 10.3529C5.00033 13.1143 7.2389 15.3529 10.0003 15.3529Z"
        fill="currentColor"
      />
      <path
        d="M9.16699 10.3529C9.16699 10.8131 8.7939 11.1862 8.33366 11.1862C7.87342 11.1862 7.50033 10.8131 7.50033 10.3529C7.50033 9.89263 7.87342 9.51953 8.33366 9.51953C8.7939 9.51953 9.16699 9.89263 9.16699 10.3529Z"
        fill="currentColor"
      />
      <path
        d="M12.5003 10.3529C12.5003 10.8131 12.1272 11.1862 11.667 11.1862C11.2068 11.1862 10.8337 10.8131 10.8337 10.3529C10.8337 9.89263 11.2068 9.51953 11.667 9.51953C12.1272 9.51953 12.5003 9.89263 12.5003 10.3529Z"
        fill="currentColor"
      />
    </svg>
  ),
})
